module.exports = __webpack_public_path__ + "static/media/merc_big_l.d040cf7f.jpg";